export default {
    bhType:[//保函类型
        {
            value: 'tbbh',
            label: '投标保函'
        }, {
            value: 'lybh',
            label: '履约保函'
        }, {
            value: 'yfkbh',
            label: '预付款保函'
        }, {
            value: 'nmggzzfbh',
            label: '农民工工资支付保函'
        }, {
            value: 'zlbxbh',
            label: '质量保修保函'
        }, {
            value: 'yzzfbh',
            label: '业主支付保函'
        },
    ]
}